import { z } from 'zod';
import * as directoryScheme from './directoryScheme';

export const machineSchema = z.object({
  id: z.number(),
  alt: z.string(),
  name: z.string(),
});

export const machineHelper =
  'Machine is a required. Please select at least one machine';
export const machinesSchema = z.array(machineSchema).min(1, machineHelper);
export const machinesOptionalSchema = z.array(machineSchema).optional();

export const nameHelper =
  'Machine name is required. It must have at least 2 characters, max 300 characters, no special characters allowed';
export const nameSchema = directoryScheme.createNameSchema({
  name: 'Machine Name',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});
export const processRouteHelper =
  'Process route is required. Please select a process route.';
export const processRouteSchema = z.string().min(1, processRouteHelper);
